import { render, staticRenderFns } from "./discord-consent.vue?vue&type=template&id=f9cc8740&"
import script from "./discord-consent.vue?vue&type=script&lang=js&"
export * from "./discord-consent.vue?vue&type=script&lang=js&"
import style0 from "./discord-consent.vue?vue&type=style&index=0&id=f9cc8740&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports